import { useEffect, useRef, useState } from "react";
import useStore from "../../store/store";
import Button from "../shared/Button";
import { _getGuestCount } from "../../utils/_getGuestCount";
import { _getRoomCount } from "../../utils/_getRoomCount";
import {
  getTotalProgramPrice,
  getTotalDisplayPrice,
  getGuestDisplayPrice,
  hasVisibleBookingDiscount,
  guestHasVisibleDiscount,
  getBookingDiscountText,
} from "../../utils/getTotalProgramPrice";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import Input from '../Input'

import 'react-phone-input-2/lib/style.css';

const FinalPage = () => {
  const { rooms, arrivalDate, decreaseStep, express, canBookRooms } = useStore();
  const [guestsCount, setGuestsCount] = useState(0);
  const [isOrderForm, setIsOrderForm] = useState(false);
  const [showForm, setShowForm] = useState(false); const phoneRef = useRef(null);
  const [showForCalls, setShowForCalls] = useState(false);
  const [formError, setFormError] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isExpress, setIsExpress] = useState(false);
  const [isNumberApproved, setIsNumberApproved] = useState('start');
  const [time, setTime] = useState(60);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    mail: ''
  });
  const [summary, setSummary] = useState(null);

  const timerInterval = useRef(null);

  const startTimer = () => {
    timerInterval.current = setInterval(() => {
      setTime(prev => prev - 1);
      if (time <= 1) {
        clearInterval(timerInterval.current);
        setIsNumberApproved('start');
      }
    }, 1000)
  }

  const textareaRef = useRef(null);
  const leftContentRef = useRef(null);
  const detailsRef = useRef(null);
  const formRef = useRef(null);

  const validatePhone = (value) => {
    const rawNumber = value.replace(/\D/g, ""); // Убираем все не-цифры
    return rawNumber.length >= 10 && rawNumber.length <= 13;
  };

  const isFormReady = () => {
    return Object.values(form).every(val => val.length > 3) && validatePhone(form.phone)
  }

  const approveNumber = async () => {
    startTimer()
    var formdata = new FormData();
    formdata.append("phone", cleanPhoneNumber(form.phone));
    setIsNumberApproved('wait');
    axios.post("https://kivach.ru/calc-new-dev2/zvonok_api.php", formdata, {
      headers: {
        "Accept": "application/json",
      },
    })
      .then(({ data }) => {
        if (data?.status === 'approved') {
          setIsNumberApproved('reserv');
        }
        if (data?.status === 'timeout') {
          setPhoneError('Подтверждение не успешно. Попробуйте еще раз.');
          setTimeout(() => {
            setPhoneError(null);
            setIsNumberApproved('start');
            clearInterval(timerInterval.current);
            setTime(60);
          }, 5000)
        }
        if (data?.error) {
          const obj = data.details[data.details.length - 1]
          setTimeout(() => {
            setPhoneError(`${obj.dial_status_display}. ${obj.status_display}`);
            setIsNumberApproved('start');
            clearInterval(timerInterval.current);
            setTime(60);
          }, 5000)
        }
      })
      .catch(error => {
        if (error.response.data.details.data.includes('No valid phone')) {
          setPhoneError('Введите корректный номер')
        }
        if (error.status === 429) {
          setPhoneError('Превышено количество попыток')
        }
        setTimeout(() => {
          setPhoneError(null);
          setIsNumberApproved('start');
          clearInterval(timerInterval.current);
          setTime(60);
        }, 5000)
      })
  }

  const goBack = () => {
    setShowForm(false);
    setIsNumberApproved('start');
    setTime(60);
    setForm({
      name: '',
      phone: '',
      mail: ''
    });
    clearInterval(timerInterval.current);
  }

  useEffect(() => {
    if (leftContentRef.current !== null) {
      setSummary(leftContentRef.current.innerHTML.replaceAll("&nbsp;", " "))
    }
  }, [])

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    const formData = new FormData(event.target);
    const details = detailsRef.current.innerHTML.replaceAll("&nbsp;", " ");
    let t = "<tr><td>" + summary.replace('<div class="final__info--people-price">Стоимость: <span>Уточните стоимость у менеджера</span></div>', '') + "</td><td>" + details + "</td></tr>";
    let timezone = -(new Date().getTimezoneOffset() / 60) - 3;
   
    if (timezone > 0) timezone = "+" + timezone;
    formData.append("table", t);
    formData.append("timezone", timezone);
    formData.append("eid", express);
    axios
      .post("https://kivach.ru/calc-new/new_calc_send.php", formData)
      .then(({ data }) => setIsSuccess(data))
      .catch((error) => {
        setFormError(error.response.data);
        setTimeout(() => {
          setFormError(null);
        }, 5000);
      })
      .finally(() => setIsLoading(false));
  };

  const handleShowForm = (isOrder) => {
    setSummary(leftContentRef.current.innerHTML.replaceAll("&nbsp;", " "))
    setShowForm(true);
    setIsOrderForm(isOrder)
  }

  const handleReserv = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let guests = 0;
      const programIds = [];
      const programTypeIds = [];
      const programLengths = [];
      const roomsId = [];
      rooms.forEach(room => {
        roomsId.push(room.apartment);
        guests = guests + room.people.length;
        room.people.forEach(person => {
          programIds.push(person.program?.id ?? null);
          programTypeIds.push(person.program_type?.id ?? null);
          programLengths.push(person.program_length ?? null);
        });
      });

      const exp = rooms.map(room => {
        return room.people.map(ppl => (ppl.express))
      }).flat();
      const formData = new FormData();
      formData.append('user_mail', form.mail);
      formData.append('user_phone', form.phone);
      formData.append('user_name', form.name);
      formData.append('guests', guests);
      formData.append('date', arrivalDate);
      formData.append('room', roomsId);
      formData.append('total', getTotalDisplayPrice(rooms));
      formData.append('prog', programIds);
      formData.append('type', programTypeIds);
      formData.append('length', programLengths);
      formData.append('user_com', textareaRef?.current?.value || '');
      formData.append("eid", exp);

    axios.post('https://kivach.ru/raif/raif_prepay.php?action=register', formData)
      .then(({ data }) => {
        const formData = new FormData(formRef.current);
        const details = detailsRef.current.innerHTML.replaceAll("&nbsp;", " ");
        let t = "<tr><td>" + summary + "</td><td>" + details + "</td></tr>";
        let timezone = -(new Date().getTimezoneOffset() / 60) - 3;
    
        if (timezone > 0) timezone = "+" + timezone;
        formData.append("table", t);
        formData.append("timezone", timezone);
        formData.append("eid", exp);
        formData.append('date', arrivalDate);
        formData.append("id", data?.id || null);
        axios.post('https://tech.kivach.ru/express/express_api.php?mode=pay_info&secret=6ea83b05ca78c1dd10981ef23c4d6742', formData);

        if (data.link.startsWith('https://')) {
          window.location.replace(data.link)
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setIsLoading(false));
  }

  function cleanPhoneNumber(phone) {
    return phone.replace(/[\s\-\(\)]/g, '');
  }
  const addDaysAndFormat = (dateStr, daysNum) => {
    let offset = 1;
    if (dateStr.startsWith("2025-01-03")) offset = 2;
    const date = new Date(dateStr);
    date.setDate(date.getDate() + +daysNum - offset);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  };

  useEffect(() => {
    let guests = 0;
    rooms.forEach(room => {
      guests = + room.people.length;
    });
    setGuestsCount(() => guests);
  }, [rooms])

  useEffect(() => {
    setTimeout(() => {
      setIsExpress(() => canBookRooms());
    }, 500);
  }, [canBookRooms])

  const formatCurrency = (value) => {
    return value ? value.toLocaleString("ru-RU") : 0;
  };

  const totalDisplayPrice = getTotalDisplayPrice(rooms);
  const bookingDiscountText = getBookingDiscountText(rooms);

  return (
    <div className="main__wrapper">
      {!isSuccess ? (
        <>
          <div className="final__header" ref={detailsRef}>
            {bookingDiscountText && (
              <p className="final__discount-text">{bookingDiscountText}</p>
            )}
            <h3>
              Дата заезда: {arrivalDate.split("-").reverse().join(".")},{" "}
              {_getRoomCount(rooms)}, {_getGuestCount(rooms)}
            </h3>
            {totalDisplayPrice > 0 ? (
              <h3>
                Стоимость:{" "}
                {hasVisibleBookingDiscount(rooms) ? (
                  <>
                    <span className="final__price--old">
                      {formatCurrency(getTotalProgramPrice(rooms))}
                    </span>{" "}
                    <span>{formatCurrency(totalDisplayPrice)}</span> ₽
                  </>
                ) : (
                  <span>{formatCurrency(totalDisplayPrice)} ₽</span>
                )}
              </h3>
            ) : (
              <h3>Ведется расчет стоимости</h3>
            )}
            <div className="divider"></div>
          </div>
          <>
            {!showForm ? (
              <div className="final__content--wrapper">
                <div className="final__content--left" ref={leftContentRef}>
                  {rooms.map((room) => (
                    <div key={room.id + "-room"} className="final__info--room">
                      {room.people.map((ppl) => (
                        <div key={ppl.id + "people"} className="final__info--people">
                          <h3>
                            Номер {room.id + 1} - {room.apartmentName}
                          </h3>
                          <div className="final__info--people-type">
                            {ppl.type === "child"
                              ? `Ребенок ${ppl.id + 1} (${ppl.name})`
                              : ppl.name.split(" ").reverse().join(" ")}
                          </div>
                          <div>
                            Программа:
                            <br /> {ppl.program.name} -{" "}
                            {ppl.program_type.name.toLowerCase()} {ppl.program_length}{" "}
                            дней
                          </div>
                          <div>
                            Дата выезда -{" "}
                            {addDaysAndFormat(arrivalDate, ppl.program_length)}
                          </div>
                          <div className="final__info--people-price">
                            Стоимость:{" "}
                            {getGuestDisplayPrice(ppl) > 0 ? (
                              guestHasVisibleDiscount(ppl) ? (
                                <>
                                  <span className="final__price--old">
                                    {formatCurrency(ppl.program_price)}
                                  </span>{" "}
                                  <span>{formatCurrency(ppl.program_discount_sum)}</span> ₽
                                </>
                              ) : (
                                <span>{formatCurrency(getGuestDisplayPrice(ppl))} ₽</span>
                              )
                            ) : (
                              <span>Уточните стоимость у менеджера</span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>

                <div className="final__content--btns">
                  <Button
                    text="Назад"
                    type="small"
                    color='green'
                    action={() => decreaseStep()} />
                  <div className="final__content--btns__with_desc">
                    <Button
                      text="Отправить заявку"
                      type="small"
                      color='green'
                      action={() => handleShowForm(true)} />
                    <span>
                      С Вами свяжется менеджер для<br /> уточнения деталей и оформления<br /> бронирования
                    </span>
                  </div>
                  {isExpress && <div className="final__content--btns__with_desc">
                    <Button
                      text="Оформить бронь онлайн"
                      type="small"
                      color='green'
                      action={() => handleShowForm(false)} />
                    <span>
                      Этот номер доступен для гарантированного бронирования онлайн. Для этого необходимо внести предоплату 25000 руб. с человека
                    </span>
                  </div>}
                </div>
              </div>
            ) : (<div className="final__content--right">
              <div
                className="error__wrapper"
                dangerouslySetInnerHTML={{ __html: formError }} />
              <form ref={formRef} onSubmit={handleSubmit}>
                <span>Введите контактные данные</span>
                <Input
                  id="uname"
                  className="form-input"
                  type="text"
                  name="name"
                  value={form.name}
                  placeholder="Введите Ваше имя"
                  required
                  pattern="[A-Za-zА-Яа-яЁё\/ \/]+"
                  onInput={({ target }) => setForm((form) => ({ ...form, [target.name]: target.value }))} />

                <PhoneInput
                  country={'ru'}
                  ref={phoneRef}
                  value={form.phone}
                  onChange={(value) => {
                    setForm((form) => ({ ...form, 'phone': value }));
                    validatePhone(value);
                  }}
                  inputProps={{
                    name: 'phone',
                    required: true,
                    autoFocus: false,
                    enableSearch: true,
                  }}
                  containerClass="phone-container"
                  inputClass={`form-input phone`} />
                <div
                  className="error__wrapper"
                  dangerouslySetInnerHTML={{ __html: phoneError }} />
                <Input
                  id="mail"
                  className="form-input"
                  type="email"
                  name="mail"
                  value={form.mail}
                  placeholder="Введите email"
                  onInput={({ target }) => setForm((form) => ({ ...form, [target.name]: target.value }))} />

                <span>Как с Вами связаться для подтверждения брони?</span>
                <fieldset>
                  <label className="checkbox-label">
                    <input
                      id="ucall"
                      name="call"
                      type="checkbox"
                      value={true}
                      onClick={({ target }) => {
                        setShowForCalls(() => target.checked);
                      }} />
                    Позвонить по номеру телефона
                  </label>
                  {showForCalls && (
                    <div id="for-calls">
                      <span>Выберите удобное время для звонка</span>
                      <div className="inputs-grid">
                        <select id="call-hour" name="call-hour">
                          <option value="9">9 часов</option>
                          <option value="10">10 часов</option>
                          <option value="11">11 часов</option>
                          <option value="12">12 часов</option>
                          <option value="13">13 часов</option>
                          <option value="14">14 часов</option>
                          <option value="15">15 часов</option>
                          <option value="16">16 часов</option>
                          <option value="17">17 часов</option>
                          <option value="18">18 часов</option>
                          <option value="19">19 часов</option>
                          <option value="20">20 часов</option>
                          <option value="21">21 час</option>
                          <option value="22">22 часа</option>
                        </select>
                        <select id="call-minutes" name="call-minutes">
                          <option value="0">0 минут</option>
                          <option value="10">10 минут</option>
                          <option value="20">20 минут</option>
                          <option value="30">30 минут</option>
                          <option value="40">40 минут</option>
                          <option value="50">50 минут</option>
                        </select>
                      </div>
                    </div>
                  )}
                  <label className="checkbox-label">
                    <input
                      id="whatsapp"
                      name="whatsapp"
                      type="checkbox"
                      value={true} />
                    Написать в WhatsApp
                  </label>
                  <label className="checkbox-label">
                    <input
                      id="telegram"
                      name="telegram"
                      type="checkbox"
                      value={true} />
                    Написать в Telegram
                  </label>
                  <label className="checkbox-label">
                    <input id="umail" name="umail" type="checkbox" value={true} />
                    Написать на email
                  </label>
                </fieldset>

                {isExpress && (
                  <>
                    <textarea
                      ref={textareaRef}
                      placeholder="Вы можете оставить комментарий к бронированию"
                      className="final__content--comment"
                      name="comment"
                      rows="3" />
                  </>
                )}

                    <div className="final__content--btns">
                      <Button
                        text="Назад"
                        color='green'
                        type="small"
                        action={() => goBack()} />
                      {!isOrderForm ? (<>
                        {isNumberApproved === 'reserv' &&
                          <div className="final__content--order-btn">
                            <Button
                              buttonType="button"
                              text="Забронировать"
                              color="green"
                              type="wide"
                              action={(e) => handleReserv(e)} />
                            <span>Аванс брони - {guestsCount * 25000} ₽</span>
                          </div>}

                        {isNumberApproved === 'start' &&
                          <div className="final__content--order-btn">
                            <Button
                              buttonType="button"
                              text="Подтвердить телефон"
                              color="green"
                              type="small"
                              action={(e) => approveNumber(e)}
                              isBtnDisabled={isLoading || !isFormReady() || formError !== null} />
                            <span>Мы совершим звонок на указанный Вами номер для его подтверждения. Это бесплатно!</span>
                          </div>}

                        {isNumberApproved === 'wait' &&
                          <div className="final__content--order-btn">
                            <Button
                              buttonType="button"
                              text="⏳"
                              color="green"
                              type="wide"
                              action={(e) => approveNumber(e)}
                              isBtnDisabled={true} />
                            <span>Ожидаем подтверждения номера.<br/>Повторный звонок доступен через {time} секунд.</span>
                          </div>}
                      </>) : (
                        <Button
                          buttonType="submit"
                          color="green"
                          text={"Отправить заявку"}
                          type="wide"
                          action={() => { }}
                          isBtnDisabled={isLoading || !isFormReady() || formError !== null} />
                      )}
                    </div>
              </form>
            </div>)}
          </>
        </>
      ) : (
        <>
          <div dangerouslySetInnerHTML={{ __html: isSuccess }} />
          <Button
            text={"Заполнить заявку заново"}
            type={"wide"}
            color={"green"}
            action={() => window.location.reload()}
          />
        </>
      )}
    </div>
  );
};

export default FinalPage;
